import { Component, EventEmitter, OnInit } from '@angular/core';
import { GeneralFormComponent } from 'src/app/components/controls/general-form/general-form.component';
import { ControlActions, TipoObjetoParaPermisos, ControllerMethods } from 'src/app/models/general.enum';
import { DataTableComponent } from 'src/app/components/controls/data-table/data-table.component';
import { ConfigWindow } from 'src/app/models/config-window';
import { FormGroup } from '@angular/forms';
import { Guid } from "guid-typescript";
import { StaticData } from '../../../helpers/static-data';
import { FileUploaderComponent } from '../../controls/file-uploader/file-uploader.component';

@Component({
  selector: 'app-external-pqrs-contact',
  templateUrl: './external-pqrs-contact.component.html',
  styleUrls: ['./external-pqrs-contact.component.scss']
})
export class ExternalPqrsContactComponent extends GeneralFormComponent implements OnInit {

  Paso = 1;
  PrimerNombre: any;
  PrimerApellido: any;
  SegundoNombre: any;
  SegundoApellido: any;
  RazonSocial: any;
  DivInfoPersonal: any;
  DivInfoDomicilio: any;
  DivPassword: any;
  DivCaracterizacion: any;
  DivExito: any;
  BtnVolver: any;
  BtnSiguiente: any;
  BtnCrud: any;
  BtnCrearSolicitud: any;
  BtnInicio: any;
  TipoContacto: any;
  IdentificacionPublica: boolean;
  UserData: any;
  Oficio: FileUploaderComponent;
  FileBoxes: Array<FileUploaderComponent> = [];
  DivDocsPersonaNatural: any;
  DivDocsPersonaJuridica: any;
  DivDocsExtranjero: any;
  DivCargueDocumentos: any;

  public OnInitEnd() {
    //debugger;
    const context = this;
    this.DivInfoPersonal = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DivInfoPersonal" });
    this.DivInfoDomicilio = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DivInfoDomicilio" });
    this.DivPassword = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DivPassword" });
    this.DivCaracterizacion = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DivCaracterizacion" });
    this.DivExito = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DivExito" });
    this.BtnVolver = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "BtnVolver" });
    this.BtnSiguiente = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "BtnSiguiente" });
    this.BtnCrud = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "BtnCrud" });
    this.BtnCrearSolicitud = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "BtnCrearSolicitud" });
    this.BtnInicio = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "BtnInicio" });
    this.PrimerNombre = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "PrimerNombre" });
    this.PrimerApellido = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "PrimerApellido" });
    this.SegundoNombre = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "SegundoNombre" });
    this.SegundoApellido = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "SegundoApellido" });
    this.RazonSocial = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "RazonSocial" });
    
    this.DivDocsPersonaNatural = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls)
      .find(x => x.Name == "DivDocsPersonaNatural");

    this.DivDocsPersonaJuridica = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls)
      .find(x => x.Name == "DivDocsPersonaJuridica");

    this.DivDocsExtranjero = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls)
      .find(x => x.Name == "DivDocsExtranjero");

    this.DivCargueDocumentos = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls)
      .find(x => x.Name == "DivCargueDocumentos");

    this.UserData = StaticData.ExternalPqrContact != undefined ? JSON.parse(StaticData.ExternalPqrContact) : StaticData.ExternalPqrContact;

    if (this.UserData != null && this.UserData != undefined) 
    {

      hideContactoFields(context, this.UserData.IdTipoContacto === 7, undefined, undefined, true);
      if(this.UserData.IdTipoContacto === 7)
      {
        this.modelo.modelo.RazonSocial = "";
        this.modelo.modelo.Cargo = "";
      }
      else if(this.UserData.IdTipoContacto === 10)
      {
        this.modelo.modelo.IdGenero = null;
      }
      this.SetModelToControls();

      if (this.UserData.IdTipoContacto !== 7) {
        $('#ConctactNav').show();
        $('#ConctactNav2').hide();
      }
      else
      {
        $('#ConctactNav').hide();
        $('#ConctactNav2').show();
      }

      this.helperActions.MultiSetControlsValue(
        [
          {
            ControlsToUpdate: ["Identificacion"],
            PropertiesToSet: {
              required: this.UserData.IdTipoContacto === 4130 ? false : true,
            },
          },
        ],
        context
      );

      this.helperActions.MultiSetControlsValue(
        [
          {
            ControlsToUpdate: ["IdTipoContacto", "IdTipoIdentificacion", "Identificacion"],
            PropertiesToSet: {
              enabled: false,
            },
          },
        ],
        context
      );

      this.SetDatosAcceso(this.UserData);
      this.MostrarDocumentosPorTipoContacto(this.UserData.IdTipoContacto,this.UserData.Codigo,
        this.UserData.TipoContacto || this.UserData.Nombre);
      this.SetCascading();
    }
    
  }

  public SetDatosAcceso(data) {
    //debugger;
    
    this.modelo.modelo.IdContacto = this.UserData.IdContacto;
    this.modelo.modelo.TipoIdentificacion = this.UserData.TipoIdentificacion;
    this.modelo.modelo.IdTipoContacto = this.UserData.IdTipoContacto;
    // this.TipoContacto = this.UserData.IdTipoContacto === 7 ? 'C' : 'E'; 
    
    this.TipoContacto = this.ObtenerTipoContactoParaFlujo(this.UserData.IdTipoContacto, 
      this.UserData.Codigo, this.UserData.TipoContacto || this.UserData.Nombre)
    this.modelo.modelo.IdTipoIdentificacion = this.UserData.IdTipoIdentificacion;
    this.modelo.modelo.Identificacion = this.UserData.Identificacion;
    this.modelo.modelo.RazonSocial = this.UserData.RazonSocial;
    this.modelo.modelo.Cargo = this.UserData.Cargo;
    this.modelo.modelo.PrimerNombre = this.UserData.PrimerNombre;
    this.modelo.modelo.SegundoNombre = this.UserData.SegundoNombre;
    this.modelo.modelo.PrimerApellido = this.UserData.PrimerApellido;
    this.modelo.modelo.SegundoApellido = this.UserData.SegundoApellido;
    this.modelo.modelo.IdGenero = this.UserData.IdGenero;
    this.modelo.modelo.CodigoPostal = this.UserData.CodigoPostal;
    this.modelo.modelo.Celular = this.UserData.Celular;
    this.modelo.modelo.Telefono = this.UserData.Telefono;
    this.modelo.modelo.Ext = this.UserData.Ext;
    this.modelo.modelo.IdPais = parseInt(this.UserData.IdPais);
    this.modelo.modelo.IdDepartamento = parseInt(this.UserData.IdDepartamento);
    this.modelo.modelo.IdCiudad = parseInt(this.UserData.IdCiudad);
    this.modelo.modelo.Direccion = this.UserData.Direccion;
    this.modelo.modelo.Correo = this.UserData.Correo;
    this.modelo.modeloCascada.IdPais = parseInt(this.UserData.IdPais);
    this.modelo.modeloCascada.IdDepartamento = parseInt(this.UserData.IdDepartamento);
    this.modelo.modeloCascada.IdCiudad = parseInt(this.UserData.IdCiudad);
    this.modelo.modelo.IdGrupoInteres = this.UserData.IdGrupoInteres
    this.modelo.modelo.IdCondicionDiscapacidad = this.UserData.IdCondicionDiscapacidad
    this.modelo.modelo.IdGrupoEtnico = this.UserData.IdGrupoEtnico
    this.modelo.modelo.IdAtencionPreferencial = this.UserData.IdAtencionPreferencial
    this.modelo.modelo.IdNivelAcademico = this.UserData.IdNivelAcademico
    
    this.SetModelToControls();
  }

  public SetCascading() {

    let arrived = 0;

    this.configs.ConfigIdPais.onLoadedEmitter = new EventEmitter<any>();
    this.configs.ConfigIdPais.onLoadedEmitter.subscribe(data => {
      //debugger;
      if (this.UserData != null && this.UserData != undefined) {
        this.modelo.modelo.IdPais = parseInt(this.UserData.IdPais);
        this.modelo.modeloCascada.IdPais = parseInt(this.UserData.IdPais);
        this.modelo.modelo.IdDepartamento = parseInt(this.UserData.IdDepartamento);
        this.modelo.modeloCascada.IdDepartamento = parseInt(this.UserData.IdDepartamento);
        this.modelo.modelo.IdCiudad = parseInt(this.UserData.IdCiudad);
        this.modelo.modeloCascada.IdCiudad = parseInt(this.UserData.IdCiudad);
        this.SetModelToControls();
        super.EditCascading();
      }
    })

    this.configs.ConfigIdTipoContacto.onLoadedEmitter = new EventEmitter<any>();
    this.configs.ConfigIdTipoContacto.onLoadedEmitter.subscribe(data => {
      //debugger;
      if (this.UserData != null && this.UserData != undefined) {
        this.modelo.modelo.IdTipoContacto = parseInt(this.UserData.IdTipoContacto);
        this.modelo.modelo.IdTipoIdentificacion = parseInt(this.UserData.IdTipoIdentificacion);
        this.SetModelToControls();
        super.EditCascading();
      }
    })

    this.configs.ConfigIdGenero.onLoadedEmitter = new EventEmitter<any>();
    this.configs.ConfigIdGenero.onLoadedEmitter.subscribe(data => {
      //debugger;
      if (this.UserData != null && this.UserData != undefined) {
        this.modelo.modelo.IdGenero = parseInt(this.UserData.IdGenero);
        this.SetModelToControls();
        super.EditCascading();
      }
    })

  }

  public PostNgAfterViewInit() {
    this.postSaveEmitter.subscribe(modelo => {
      //debugger;

      var Message = "";
      if(this.modelo.modelo.IdContacto != null && this.modelo.modelo.IdContacto != "")
      {
        Message = "Sus datos han sido actualizados correctamente";
      }
      else
      {
        Message = "El usuario ha sido creado correctamente";
      }

      this.utility.VerModalOk(Message).then(modelo => {
        if(this.TipoContacto == "C")
              {
                $('#bar__active2').removeClass("bar-active-4_").addClass("bar-active-5_");
              }
              else
              {
                $('#bar__active').removeClass("bar-active-3").addClass("bar-active-4");
              }
               
        if (modelo.dialogResult == true) {
          $('.ms-Overlay.is-visible').remove();
          StaticData.ExternalPqrContact = null;
          StaticData.ContactAuthenticated = false;
          StaticData.ExternalPqrAnonimo = false;
          var CurrentUrl = window.location.href;
          window.location.href = CurrentUrl.replace('ExternalPQR', 'HomeExternalPQR');

        }
      });

    });
  }  
  //Carga de documentos Proveedores
  public AddComponentInstanceHandler(event) {
		if (event instanceof FileUploaderComponent) {
        if (event.name == "ArchivoOficio")
            this.Oficio = event;
        else
            this.FileBoxes.push(event);
    }
    super.AddComponentInstanceHandler(event);
	}

  public OnActionEventHandler(event) {
    //debugger;
    if(this.UserData && this.Paso != 3){
      this.modelo.modelo.IdGrupoInteres = this.UserData.IdGrupoInteres
      this.modelo.modelo.IdCondicionDiscapacidad = this.UserData.IdCondicionDiscapacidad
      this.modelo.modelo.IdGrupoEtnico = this.UserData.IdGrupoEtnico
      this.modelo.modelo.IdAtencionPreferencial = this.UserData.IdAtencionPreferencial
      this.modelo.modelo.IdNivelAcademico = this.UserData.IdNivelAcademico

      this.SetModelToControls();
    }
    if (event.Name == "BtnVolver") {
      switch (this.Paso) {
        case 2:
          this.DivInfoDomicilio.Hidden = true;
          this.DivInfoPersonal.Hidden = false;
          this.BtnVolver.Hidden = true;
          // this.DivInfoDomicilio.required = true;
          
          if(this.TipoContacto == "C")
          {
            $('#bar__active2').removeClass("bar-active-2_").addClass("bar-active_");
          }
          else
          {
            $('#bar__active').removeClass("bar-active-2").addClass("bar-active");
          }          
          this.Paso = 1;
          break;
        case 3:
          this.DivCaracterizacion.Hidden = true;
          this.DivInfoDomicilio.Hidden = false;
          this.BtnVolver.Hidden = false;
          this.BtnSiguiente.Hidden = false;
          this.BtnCrud.Hidden = true;
          if(this.TipoContacto == "C")
          {
            $('#bar__active2').removeClass("bar-active-3_").addClass("bar-active-2_");
          }
          else
          {
            $('#bar__active').removeClass("bar-active-3").addClass("bar-active-2");
          }          
          this.Paso = 2;
          break;
        case 4:
          this.DivPassword.Hidden = true;
          this.BtnVolver.Hidden = false;
          this.BtnSiguiente.Hidden = false;
          this.BtnCrud.Hidden = true;
          if(this.TipoContacto == "C")
          {
            this.DivCaracterizacion.Hidden = false;
            $('#bar__active2').removeClass("bar-active-4_").addClass("bar-active-3_");
            this.Paso = 3;
          }
          else
          {
            this.DivInfoDomicilio.Hidden = false;
            $('#bar__active').removeClass("bar-active-3").addClass("bar-active-2");
            this.Paso = 2;
          }          
          break;
      }
    }
    else if (event.Name == "BtnSiguiente") {
      switch (this.Paso) {
        case 1:
          console.log(this.modelo.modelo);
          var requiredcontrols = false;
          //debugger;
          if(this.modelo.modelo.IdTipoContacto == null||
            this.modelo.modelo.PrimerNombre == null||
            this.modelo.modelo.IdTipoIdentificacion == null||
            this.modelo.modelo.Identificacion == null||
            (this.TipoContacto == "C" && this.modelo.modelo.IdGenero == null)||
            (this.TipoContacto == "E" && (this.modelo.modelo.RazonSocial == null||this.modelo.modelo.Cargo == null) )){
            this.utility.VerModalWarning({
              titulo: 'Alerta', descripcion: 'Los campos señalados son requeridos.',
              verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
            });
            break;
          }

          if(this.TipoContacto == "C") 
          {
            if
            (
              (this.modelo.modelo.PrimerNombre == null || this.modelo.modelo.PrimerNombre == "") || 
              (this.modelo.modelo.PrimerApellido == null || this.modelo.modelo.PrimerApellido == "") ||
              this.modelo.modelo.IdTipoIdentificacion == null || this.modelo.modelo.IdGenero == null ||
              (this.modelo.modelo.Identificacion == null || this.modelo.modelo.Identificacion == "")
            )
            {
              this.modelo.modelo.IdGenero.required = true;
              requiredcontrols = true;
            }
          }
          else if(this.TipoContacto == "E") 
          {
            if
            (
              (this.modelo.modelo.PrimerNombre == null || this.modelo.modelo.PrimerNombre == "") || 
              (this.modelo.modelo.PrimerApellido == null || this.modelo.modelo.PrimerApellido == "") ||
              this.modelo.modelo.IdTipoIdentificacion == null ||
              (this.modelo.modelo.Identificacion == null || this.modelo.modelo.Identificacion == "") ||
              (this.modelo.modelo.RazonSocial == null || this.modelo.modelo.RazonSocial == "") ||
              (this.modelo.modelo.Cargo == null || this.modelo.modelo.Cargo == "") 
            )
            {
              requiredcontrols = true;
            }
          }
          else if(this.TipoContacto == "PUB") 
          {
            if(this.IdentificacionPublica)
            {
              if
              (
                (this.modelo.modelo.PrimerNombre == null || this.modelo.modelo.PrimerNombre == "") || 
                (this.modelo.modelo.PrimerApellido == null || this.modelo.modelo.PrimerApellido == "") ||
                this.modelo.modelo.IdTipoIdentificacion == null ||
                (this.modelo.modelo.RazonSocial == null || this.modelo.modelo.RazonSocial == "") ||
                (this.modelo.modelo.Cargo == null || this.modelo.modelo.Cargo == "") 
              )
              {
                requiredcontrols = true;
              }
            }
            else
            {
              if
              (
                (this.modelo.modelo.PrimerNombre == null || this.modelo.modelo.PrimerNombre == "") || 
                (this.modelo.modelo.PrimerApellido == null || this.modelo.modelo.PrimerApellido == "") ||
                this.modelo.modelo.IdTipoIdentificacion == null ||
                (this.modelo.modelo.Identificacion == null || this.modelo.modelo.Identificacion == "") ||
                (this.modelo.modelo.RazonSocial == null || this.modelo.modelo.RazonSocial == "") ||
                (this.modelo.modelo.Cargo == null || this.modelo.modelo.Cargo == "") 
              )
              {
                requiredcontrols = true;
              }
            }
            
          }
          
          if(!requiredcontrols && !this.IdentificacionPublica) 
          {
            //debugger;
            if(this.modelo.modelo.IdContacto == null && this.modelo.modelo.IdContacto == undefined)
            {
              var obj = this.utility.GetApiModel('ValidarInformacionContacto', this.componentName);
              obj.QueryConfig.Command = 'ValidarInformacionContacto';
              obj.QueryConfig.IsSp = true;
              //debugger;
              obj.QueryConfig.Entity = { IdTipoIdentificacion: this.modelo.modelo.IdTipoIdentificacion, Identificacion: this.modelo.modelo.Identificacion };

              this.baseService.Get(obj, null,
              {
                componentName: this.componentName,
                method: 'ValidarInformacionContacto',
                processMessage: 'Verificando información del usuario...'
              }, 'RContacto')
              .then(data => {
                //debugger;
                if (data.Data[0] != null || data.Data[0] != undefined) {
                  this.utility.VerModalWarning({
                    titulo: 'Alerta', descripcion: 'Ya se encuentra creado un usuario con el tipo de documento e identificación seleccionados',
                    verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
                  }).then(data => { });
                }
                else {
                  this.DivInfoPersonal.Hidden = true;
                  this.DivInfoDomicilio.Hidden = false;
                  this.BtnVolver.Hidden = false;
                  if(this.TipoContacto == "C")
                  {
                    $('#bar__active2').removeClass("bar-active_").addClass("bar-active-2_");
                  }
                  else
                  {
                    $('#bar__active').removeClass("bar-active").addClass("bar-active-2");
                  }                  
                  this.Paso = 2;
                }
              }).catch(err => {
                this.utility.logger.LogError(err, obj, {
                  componentName: this.componentName,
                  method: 'ValidarInformacionContacto',
                  processMessage: 'Verificando información del usuario...'
                }, 'RContacto')
              });
            
            }
            else
            {
                this.DivInfoPersonal.Hidden = true;
                this.DivInfoDomicilio.Hidden = false;
                this.BtnVolver.Hidden = false;
                if(this.modelo.modelo.IdTipoContacto == 7)
                {
                  $('#bar__active2').removeClass("bar-active_").addClass("bar-active-2_");
                }
                else
                {
                  $('#bar__active').removeClass("bar-active").addClass("bar-active-2");
                }                  
                this.Paso = 2;
            }
          }
          else
          {
            this.utility.VerModalWarning({
              titulo: 'Alerta', descripcion: 'Los campos señalados son requeridos.',
              verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
            });
          }
          break;
        case 2:

          if
          (
            this.modelo.modeloCascada.IdPais == null || 
            this.modelo.modeloCascada.IdDepartamento == null || 
            this.modelo.modelo.IdCiudad == null || 
            (this.modelo.modelo.Direccion == null || this.modelo.modelo.Direccion == "") || 
            (this.modelo.modelo.Celular == null || this.modelo.modelo.Celular == "") || 
            (this.modelo.modelo.Correo == null || this.modelo.modelo.Correo == "") || 
            (this.modelo.modelo.ConfirmCorreo == null || this.modelo.modelo.ConfirmCorreo == "") 
          )
          {
            this.utility.VerModalWarning({
              titulo: 'Alerta', descripcion: 'Los campos señalados son requeridos.',
              verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
            });
          }
          else{
            if (this.modelo.modelo.Correo == this.modelo.modelo.ConfirmCorreo) 
            {
              this.DivInfoDomicilio.Hidden = true;
              this.BtnVolver.Hidden = false;
              
              if(this.TipoContacto == "C")
              {
                this.DivCaracterizacion.Hidden = false;
                this.BtnSiguiente.Hidden = false;
                this.BtnCrud.Hidden = true;
                $('#bar__active2').removeClass("bar-active-2_").addClass("bar-active-3_");
                this.Paso = 3;
              }
              else
              {
                this.DivPassword.Hidden = false;
                this.BtnSiguiente.Hidden = true;
                this.BtnCrud.Hidden = false;
                $('#bar__active').removeClass("bar-active-2").addClass("bar-active-3");
                this.Paso = 4;
              }                  
              
            }
            else {
              this.utility.VerModalWarning({
                titulo: 'Alerta', descripcion: 'Los correos ingresados no coinciden.',
                verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
              });
            }
          }          
          break;
        case 3:
          this.DivCaracterizacion.Hidden = true;
          this.DivPassword.Hidden = false;
          this.BtnVolver.Hidden = false;
          this.BtnSiguiente.Hidden = true;
          this.BtnCrud.Hidden = false;
          $('#bar__active2').removeClass("bar-active-3_").addClass("bar-active-4_");
          this.Paso = 4;

          break;
      }
    }
    else if (event.Name == "btnGuardar") {
      //debugger;

      
        if (this.modelo.modelo.Password != this.modelo.modelo.ConfirmPassword) {
          this.utility.VerModalWarning({
            titulo: 'Alerta', descripcion: 'Las contraseñas ingresadas no coinciden.',
            verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
          });
          this.SetProcesando(true);
        }
        else {
          this.DivPassword.Hidden = true;
          this.DivExito.Hidden = false;
          this.BtnCrearSolicitud.Hidden = false;
          this.BtnInicio.Hidden = false;
          super.OnActionEventHandler(event);
        }
            
    }
    else if (event.Name == "BtnCrearSolicitud") {
      var CurrentUrl = window.location.href;
      window.location.href = CurrentUrl.replace('ExternalPQRContact', 'ExternalPQRs');
    }
    else if (event.Name == "BtnInicio") {
      var CurrentUrl = window.location.href;
      window.location.href = CurrentUrl.replace('ExternalPQRContact', 'HomeExternalPQR');
    }
    ///Inicio Implementación temporal Cuenta Contrato
    else if (event.Name == "BtnCuentaContrato"){
      // debugger;
      if (this.modelo.modeloVirtual.CuentaContrato){
        var obj = this.utility.GetApiModel('SQLQ_ConsultarCuentaContratoSAP', this.componentName);
        obj.QueryConfig.Command = 'SQLQ_ConsultarCuentaContratoSAP';
        obj.QueryConfig.IsSp = true;
        obj.QueryConfig.Entity = { CuentaContrato: this.modelo.modeloVirtual.CuentaContrato };

        this.baseService.Get(obj, null,
        {
          componentName: this.componentName,
          method: 'SQLQ_ConsultarCuentaContratoSAP',
          processMessage: 'Verificando información de Cuenta Contrato...'
        }, 'RContacto')
        .then(data => {
          if (data.Data[0] != null || data.Data[0] != undefined) {
            this.modelo.modelo.PrimerNombre = data.Data[0]["PrimerNombre"];
            this.modelo.modelo.SegundoNombre = data.Data[0]["SegundoNombre"];
            this.modelo.modelo.PrimerApellido = data.Data[0]["PrimerApellido"];
            this.modelo.modelo.SegundoApellido = data.Data[0]["SegundoApellido"];
            this.modelo.modeloVirtual.GeoEstrReg = data.Data[0]["GeoEstrReg"];
            this.modelo.modelo.Direccion = data.Data[0]["Direccion"];
            data.Data[0]["Telefono"].length > 7 ? this.modelo.modelo.Celular = data.Data[0]["Telefono"] :  this.modelo.modelo.Telefono = data.Data[0]["Telefono"];
            this.modelo.modelo.Correo = data.Data[0]["Correo"];

            this.modelo.modeloCascada.IdPais = parseInt(data.Data[0]["IdPais"]);
            this.modelo.modeloCascada.IdDepartamento = parseInt(data.Data[0]["IdDepartamento"]);
            this.modelo.modeloCascada.IdCiudad = parseInt(data.Data[0]["IdCiudad"]);
            this.modelo.modelo.IdCiudad = this.modelo.modeloCascada.IdCiudad;
            this.SetModelToControls();
            super.EditCascading();
            this.utility.VerModalOk("Propietario encontrado con Cuenta Contrato: " + "\n\r" + this.modelo.modeloVirtual.CuentaContrato);
          }
          else {
            this.utility.VerModalWarning({
              titulo: 'Alerta', descripcion: 'No se encontraron datos asociados con la Cuenta Contrato: '+ this.modelo.modeloVirtual.CuentaContrato,
              verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
            }).then(data => { });
          }
        }).catch(err => {
          this.utility.logger.LogError(err, obj, {
            componentName: this.componentName,
            method: 'SQLQ_ConsultarCuentaContratoSAP',
            processMessage: 'Verificando información de Cuenta Contrato...'
          }, 'RContacto')
        });
      }
    }
    ///Fin Implementación temporal Cuenta Contrato
    else
      super.OnActionEventHandler(event);
  }

  private OcultarListasDocumentosProveedor() {
    if (this.DivDocsPersonaNatural) {
      this.DivDocsPersonaNatural.Hidden = true;
    }

    if (this.DivDocsPersonaJuridica) {
      this.DivDocsPersonaJuridica.Hidden = true;
    }

    if (this.DivDocsExtranjero) {
      this.DivDocsExtranjero.Hidden = true;
    }
  }

  private NormalizarTexto(valor: any): string {
    return valor ? valor.toString().trim().toUpperCase() : "";
  }

  private ObtenerIdsTipoContacto(control: any): number[] {
    if (!control || !control.IdTiposContacto) {
      return [];
    }

    return control.IdTiposContacto
      .map(x => Number(x))
      .filter(x => !isNaN(x));
  }

  private ObtenerCodigosTipoContacto(control: any): string[] {
    if (!control || !control.CodigosTipoContacto) {
      return [];
    }

    return control.CodigosTipoContacto.map(x => this.NormalizarTexto(x));
  }

  private ObtenerNombresTipoContacto(control: any): string[] {
    if (!control || !control.NombresTipoContacto) {
      return [];
    }

    return control.NombresTipoContacto.map(x => this.NormalizarTexto(x));
  }

  private CoincideTipoContacto(control: any, idTipoContacto: any, codigo?: string, nombre?: string): boolean {
    if (!control) {
      return false;
    }

    const id = Number(idTipoContacto);
    const codigoNormalizado = this.NormalizarTexto(codigo);
    const nombreNormalizado = this.NormalizarTexto(nombre);

    const ids = this.ObtenerIdsTipoContacto(control);
    const codigos = this.ObtenerCodigosTipoContacto(control);
    const nombres = this.ObtenerNombresTipoContacto(control);

    if (!isNaN(id) && ids.indexOf(id) >= 0) {
      return true;
    }

    if (codigoNormalizado && codigos.indexOf(codigoNormalizado) >= 0) {
      return true;
    }

    if (nombreNormalizado && nombres.indexOf(nombreNormalizado) >= 0) {
      return true;
    }

    return false;
  }

  private ObtenerControlDocumentosDefault(): any {
    if (this.DivDocsPersonaNatural && this.DivDocsPersonaNatural.EsDefaultDocumentos) {
      return this.DivDocsPersonaNatural;
    }

    return this.DivDocsPersonaNatural;
  }

  private MostrarDocumentosPorTipoContacto(idTipoContacto: any, codigo?: string, nombre?: string) {
    this.OcultarListasDocumentosProveedor();

    const controles = [
      this.DivDocsPersonaNatural,
      this.DivDocsPersonaJuridica,
      this.DivDocsExtranjero
    ];

    const controlEncontrado = controles.find(control =>
      this.CoincideTipoContacto(control, idTipoContacto, codigo, nombre)
    );

    if (controlEncontrado) {
      controlEncontrado.Hidden = false;
      return;
    }

    const controlDefault = this.ObtenerControlDocumentosDefault();

    if (controlDefault) {
      controlDefault.Hidden = false;
    }
  }


  private ObtenerTipoContactoParaFlujo(idTipoContacto: any, codigo?: string, nombre?: string): string {
    const id = Number(idTipoContacto);
    const codigoNormalizado = this.NormalizarTexto(codigo);
    const nombreNormalizado = this.NormalizarTexto(nombre);

    if (
      id === 7 ||
      id === 61 ||
      codigoNormalizado === "C" ||
      codigoNormalizado === "PN" ||
      nombreNormalizado === "CIUDADANO" ||
      nombreNormalizado === "PERSONA NATURAL"
    ) {
      return "C";
    }

    return "E";
  }

  private LimpiarArchivoOficio() {
    if (this.modelo && this.modelo.modelo) {
      this.modelo.modelo.ArchivoOficio = null;
    }

    if (this.modelo && this.modelo.modeloVirtual) {
      this.modelo.modeloVirtual.ArchivoOficio = null;
    }

    const fileBox: any = this.Oficio;

    if (fileBox && typeof fileBox.ClearFilesFromParent === "function") {
      fileBox.ClearFilesFromParent();
      return;
    }

    if (fileBox && typeof fileBox.resetFileUpload === "function") {
      fileBox.resetFileUpload();
    }
  }

  public OnSelectedComboBox(item: any, controlName: string, config: any) {
    //debugger;
    const context = this;
    switch (controlName) {
      case "IdTipoIdentificacion": {
        //debugger;
        this.IdentificacionPublica = item.IdDatoBasico == 60 ? true : false;
        const context = this;
 
      /*this.helperActions.MultiSetControlsValue(
        [
          {
            ControlsToUpdate: ["Identificacion"],
            PropertiesToSet: {
              required: item.IdDatoBasico == 60 ? false : true,
            },
          },
        ],
        context
      );*/

        /*if (item.IdDatoBasico == 16) {
          const context = this;
          const action = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["PrimerNombre", "PrimerApellido"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "false",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.helperActions.SetControlsValue(action, context);

          const actionRS = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["RazonSocial", "PrimerNombre", "PrimerApellido"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "true",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.modelo.modelo.IdTipoContacto = 10;
          this.helperActions.SetControlsValue(actionRS, context);

          //this.PrimerNombre.Hidden = true;
          //this.SegundoNombre.Hidden = true;
          //this.PrimerApellido.Hidden = true;
          //this.SegundoApellido.Hidden = true;
          this.RazonSocial.Hidden = false;

        }
        else {
          const context = this;
          const action = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["PrimerNombre", "PrimerApellido"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "true",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.helperActions.SetControlsValue(action, context);

          const actionRS = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["RazonSocial"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "false",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.modelo.modelo.IdTipoContacto = 7;
          this.helperActions.SetControlsValue(actionRS, context);

          this.PrimerNombre.Hidden = false;
          this.SegundoNombre.Hidden = false;
          this.PrimerApellido.Hidden = false;
          this.SegundoApellido.Hidden = false;
          this.RazonSocial.Hidden = true;

        }*/

        break;
      }
      case "IdTipoContacto":
      {
        // debugger
        this.modelo.modelo.IdTipoIdentificacion = null;
        if (item && item.hasOwnProperty("Codigo")) 
        {
          // debugger
          this.LimpiarArchivoOficio();

          this.TipoContacto = this.ObtenerTipoContactoParaFlujo(
            item.IdDatoBasico,
            item.Codigo,
            item.Nombre
          );
          
          this.MostrarDocumentosPorTipoContacto(
            item.IdDatoBasico,
            item.Codigo,
            item.Nombre
          );
          
            //if (item.Codigo !== "PUB") {
              hideContactoFields(context, this.TipoContacto === "C", undefined, undefined, true);
              if(this.TipoContacto === "C")
              {
                this.modelo.modelo.RazonSocial = "";
                this.modelo.modelo.Cargo = "";
              }
              else 
              {
                this.modelo.modelo.IdGenero = "";
              }
              
              this.SetModelToControls();
            //}

            if (this.TipoContacto !== "C") {
              $('#ConctactNav').show();
              $('#ConctactNav2').hide();
            }
            else
            {
              $('#ConctactNav').hide();
              $('#ConctactNav2').show();
            }
      
            this.helperActions.MultiSetControlsValue(
              [
                {
                  ControlsToUpdate: ["Identificacion"],
                  PropertiesToSet: {
                    required: item.Codigo == "PUB" ? false : true,
                  },
                },
              ],
              context
            );
      
          }
        break;
      }
      case "IdPais":
        {
          this.modelo.modelo.IdDepartamento = null;
          this.modelo.modeloCascada.IdDepartamento = null;
          this.modelo.modelo.IdCiudad = null;
          this.modelo.modeloCascada.IdCiudad = null;
          break;
        }
      case "IdDepartamento":
        {
          this.modelo.modelo.IdCiudad = null;
          this.modelo.modeloCascada.IdCiudad = null;
          break;
        }
    }

    this.SetModelToControls();

    super.OnSelectedComboBox(item, controlName, config);
  }


  public GuardarForm(event) {
    //debugger;
    try {

      if(this.modelo.modelo.IdContacto != null && this.modelo.modelo.IdContacto != "")
      {
        this.modelo.modelo.PkValue = this.modelo.modelo.IdContacto;
      }

      if
      (
        (this.modelo.modelo.Password == null || this.modelo.modelo.Password == "" || this.modelo.modelo.Password == undefined) || 
        (this.modelo.modelo.ConfirmPassword == null || this.modelo.modelo.ConfirmPassword == "" || this.modelo.modelo.Password == undefined)
      )
      {
        this.utility.VerModalWarning({
          titulo: 'Alerta', descripcion: 'Los campos señalados son requeridos.',
          verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
        });
      }
      else
      {
        if (this.modelo.modelo.Password == this.modelo.modelo.ConfirmPassword) {
          this.modelo.modelo.Password = btoa(this.modelo.modelo.Password);
          
          let obj: any = null;
          obj = this.utility.GetApiModel("Guardar", this.componentName, null, null, this.modelo.modelo);

          if (this.componentsContainer.FileBox && this.componentsContainer.FileBox.isSelectedFiles()) {              
              obj.IdContacto = !obj.IdContacto ? 0 : obj.IdContacto;
              this.componentsContainer.FileBox.uploadFiles(false, obj, null);
          }else{
            super.GuardarForm(event);
          }
        }
        else {
          this.utility.VerModalWarning({
            titulo: 'Alerta', descripcion: 'Las contraseñas ingresadas no coinciden.',
            verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
          });
          this.SetProcesando(false);
        }
      }
    }
    catch (error) {
      this.utility.logger.LogError(error, null, { componentName: this.componentName, method: '_Guardar' });
      this.utility.VerModalDanger().then(data => { })
      this.SetProcesando(false);
    }
  }

  /*_Guardar(form: FormGroup, configButtons?: any) {
    debugger;
    try {
      if (this.modelo.modelo.Password == this.modelo.modelo.ConfirmPassword) {
        this.modelo.modelo.Password = btoa(this.modelo.modelo.Password);
        super._Guardar(form, configButtons);
      }
      else {
        this.utility.VerModalWarning({
          titulo: 'Alerta', descripcion: 'Las contraseñas ingresadas no coinciden.',
          verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
        });
        this.SetProcesando(false);
      }
    }
    catch (error) {
      this.utility.logger.LogError(error, null, { componentName: this.componentName, method: '_Guardar' });
      this.utility.VerModalDanger().then(data => { })
      this.SetProcesando(false);
    }
  }*/

}

export function hideContactoFields(
  context,
  esCiudadano = true,
  camposOcultarCiudadano = ["Cargo", "RazonSocial"],
  camposOcultarEmpresa = ["IdGenero"],
  marcarRequerido = false
) {
  return (
    context.helperActions &&
    context.helperActions.MultiSetControlsValue &&
    context.helperActions.MultiSetControlsValue(
      [
        {
          ControlsToUpdate: camposOcultarCiudadano,
          PropertiesToSet: {
            hidden: esCiudadano,
            required: !esCiudadano && marcarRequerido,
          },
        },
        {
          ControlsToUpdate: camposOcultarEmpresa,
          PropertiesToSet: {
            hidden: !esCiudadano,
            required: esCiudadano && marcarRequerido,
          },
        },
      ],
      context
    )
  );
}
